import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {Service} from "../../../models/service.model";
import * as _ from "lodash";

require('./service-service-areas-indication.scss');
@Component({
  standalone: false,
  selector: 'app-service-service-areas-indication',
  templateUrl: './service-service-areas-indication.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceServiceAreasIndicationComponent implements OnInit, OnChanges {


  @Input() service: Service;
  @Input() maxItems: number;

  public areaNames: string[];

  ngOnInit() {
    if (!this.maxItems) {
      this.maxItems = 3;
    }

    this._initServiceAreaNames();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.service && !changes.service.isFirstChange()) {
      this._initServiceAreaNames();
    }
  }

  private _initServiceAreaNames() {
    const tasks = _.get(this.service, 'taskList', []);
    this.areaNames = _.chain(tasks)
      .map(t => {
        const areasMap = _.get(t, 'taskSpec.address.areaIdToNameMap');
        return !!areasMap ? _.map(_.get(t, 'taskSpec.address.areaIdToNameMap', {}), (value, key) => {
          return value;
        }) : undefined;
      })
      .compact()
      .flatMap()
      .uniq()
      .value();
  }

}
